import cloneDeep from "lodash/cloneDeep";

import { DesignData, Spread } from "editor/src/store/design/types";

import { ReflectContext } from "./getReflectContext";
import reflectMediaElements from "./reflectMediaElements";
import { Mode } from "./utils";

export const reflectSpreadAndApply = ({
  sourceSpread,
  destSpread,
  sourceDesign,
  newDesign,
  sourceSpreadIndex,
  context,
  mode = "adapt",
}: {
  sourceSpread: Spread;
  destSpread: Spread;
  sourceDesign: DesignData;
  newDesign: DesignData;
  sourceSpreadIndex: number;
  context: ReflectContext;
  mode?: Mode;
}) => {
  destSpread.layoutSchemaName = sourceSpread.layoutSchemaName;
  destSpread.sceneId = sourceSpread.sceneId;
  destSpread.conditionGroup = cloneDeep(sourceSpread.conditionGroup);

  // GAPI-30848 — Strip the multi-tech placeholder tag once we reflect a real
  // source spread's content onto this dest. The bridge stamps every cloned-
  // from-spreads[0] augmentation with `__multiTechPlaceholder` so the iframe
  // can ignore them when seeding `selectedTechByArea` on Edit-designs reopen.
  // After reflection though, dest no longer carries cloned content — it now
  // owns the customer's saved per-area artwork. Keeping the tag would hide
  // the spread from the artwork-aware default picker and reopen the wizard
  // on the wrong tech (e.g. Front=DTF when customer published Front=DTG).
  if (Array.isArray(destSpread.tags) && destSpread.tags.length) {
    destSpread.tags = destSpread.tags.filter(
      (t) => t !== "__multiTechPlaceholder",
    );
    if (!destSpread.tags.length) {
      delete destSpread.tags;
    }
  }

  const sourceFirstPage = sourceSpread.pages[0];
  if (!sourceFirstPage || !destSpread.pages[0]) {
    return;
  }

  const mediaContext = (context.fonts || context.gridDesigns) && {
    fonts: context.fonts || [],
    gridDesigns: context.gridDesigns || [],
  };
  const media = reflectMediaElements(
    sourceSpread,
    sourceFirstPage,
    destSpread,
    context.layouts,
    mode,
    sourceSpreadIndex,
    sourceDesign,
    newDesign,
    mediaContext,
  );

  sourceSpread.pages.forEach((sourcePage, pageIndex) => {
    const destPage = destSpread.pages[pageIndex];
    if (!destPage) {
      return;
    }

    destPage.backgroundColor = sourcePage.backgroundColor;

    sourcePage.groups.content?.forEach((sourceContent) => {
      if (sourceContent.type === "sample") {
        return;
      }
      const destContent = destPage.groups.content?.find(
        (content) => content.name === sourceContent.name,
      );
      if (destContent) {
        destContent.extra = cloneDeep(sourceContent.extra);
      }
    });

    destPage.groups.media = media;
  });
};

export default reflectSpreadAndApply;
